export enum MediaTypeCode
    {
        VIDEO = 'VIDEO',
        AUDIO = 'AUDIO',
        DOCUMENT = 'DOC',
        IMAGE = 'IMG',
        PREVIEW = 'PREVIEW',
    }
